"use client";

import React, { useRef } from "react";
import { MsalProvider } from "@azure/msal-react";
import { useRouter } from "next/navigation";
import { CustomNavigationClient } from "@utils/navigationClient";
import { MsalInstanceFactory } from "./Msal";
import { LayoutProps } from "@lib/definitions";


const MsalWrapperB2C = ({ children }: LayoutProps) => {
    const msalInstanceRef = useRef<ReturnType<typeof MsalInstanceFactory> | null>(null);
    if (!msalInstanceRef.current) {
        msalInstanceRef.current = MsalInstanceFactory(true);
    }
    const msalInstance = msalInstanceRef.current;
    msalInstance.setNavigationClient(new CustomNavigationClient(useRouter()));

    return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};

export default MsalWrapperB2C;